
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Form } from 'element-ui';
import moment from 'moment';
import { toast } from '../../../../utils/common';
import LogUtils from 'panda-log';
import { iPromoteCode, eType, eRechargeType, eVilidityDateType } from '@/interface/promote-code';
import { addPromoteCode } from '@/api/promote-code';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD');
    },
  },
})
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() title!: string;
  @Prop() info!: iPromoteCode;

  loading = false;
  private coin: eType = eType.COIN;
  private weekcard: eType = eType.WEEKCARD;
  private cash: eType = eType.CASH;
  private start_ts: any = null;
  private end_ts: any = null;
  private noLimit: eRechargeType = eRechargeType.NOLIMIT;
  private limit: eRechargeType = eRechargeType.LIMIT;
  private getDate: eVilidityDateType = eVilidityDateType.GETDATE;
  private fixeDate: eVilidityDateType = eVilidityDateType.FIXEDATE;
  private rechargeTypeIndex: eRechargeType = this.noLimit; //充值类型
  private vilidityDateIndex: eVilidityDateType = this.fixeDate; //领取时间方式
  private model: any = {};
  typeList = [
    { id: this.coin, name: '云币' },
    { id: this.weekcard, name: '周期卡' },
    { id: this.cash, name: '现金券' },
  ];
  rechargeType = [
    { id: this.noLimit, name: '不限制金额' },
    { id: this.limit, name: '限制金额' },
  ];
  vilidityDateType = [
    { id: this.getDate, name: '按领取时间' },
    { id: this.fixeDate, name: '固定时间段' },
  ];
  rules: any = {
    name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
    expire_at: [{ required: true, message: '请选择有效日期', trigger: 'blur' }],
    amount: [{ required: true, validator: this.validatorAmount, trigger: 'blur' }],
    weekAmount: [{ required: true, validator: this.validatorWeekAmount, trigger: 'blur' }],
    cashAmount: [{ required: true, validator: this.validatorCashAmount, trigger: 'blur' }],
    validDate: [{ required: true, validator: this.validDate, trigger: 'blur' }],
    title: [{ required: true, validator: this.validTitle, trigger: 'blur' }],
    valid_days: [{ required: true, validator: this.validDays, trigger: 'blur' }],
  };
  /* 云币 */
  validatorAmount(rule: any, value: any, callback: any) {
    const amount = this.model.extend.amount;
    if (this.model.type != this.coin || (amount != null && amount > 0)) {
      callback();
    } else {
      return callback(new Error('请输入云币，且云币必须为大于0'));
    }
  }
  public pickerOptions: any = {
    disabledDate: (time: any) => {
      //disabledDate是官方提供的一个方法

      return time.getTime() < Date.now() - 8.64e7; //限制时间只能选择今天以后的
    },
  };

  /* 现金券 */
  validatorCashAmount(rule: any, value: any, callback: any) {
    const amount = this.model.extend.cashAmount ? this.model.extend.cashAmount : 0;

    if (this.model.type != this.cash || (amount != null && amount > 0)) {
      if (amount.toString().length > 3) {
        return callback(new Error('金额总位数不能超过3位'));
      } else {
        callback();
      }
    } else {
      return callback(new Error('请输入大于0的现金券金额'));
    }
  }
  /* 验证周期卡时长 */
  validatorWeekAmount(rule: any, value: any, callback: any) {
    if (this.model.type != this.weekcard || this.model.extend.weekAmount == null) {
      callback();
    } else {
      if (this.model.extend.weekAmount <= 0) {
        return callback(new Error('请输入大于0时长，不填时长，则为无限时长'));
      } else {
        callback();
      }
    }
  }
  /* 验证有效期 */
  validDate(rule: any, value: any, callback: any) {
    const expire_at = this.model.expire_at;
    if (this.model.type != this.cash) {
      callback();
    } else {
      //固定时间
      if (this.vilidityDateIndex == this.fixeDate) {
        if (this.start_ts == null || this.end_ts == null) {
          return callback(new Error('请选择开始时间和过期时间'));
        } else if (this.start_ts > this.end_ts) {
          return callback(new Error('过期时间必须大于开始时间'));
        } else if (expire_at && expire_at > this.end_ts) {
          return callback(new Error('现金券的有效期的结束时间需要大于等于兑换过期时间'));
        } else {
          callback();
        }
      } else {
        const valid_days = this.model.extend.valid_days;
        //领取时间
        if (valid_days && valid_days > 0) {
          callback();
        } else {
          return callback(new Error('请输入大于0的天数'));
        }
      }
    }
  }
  validTitle(rule: any, value: any, callback: any) {
    if (this.model.type != this.weekcard || this.model.extend.title.length > 0) {
      callback();
    } else {
      return callback(new Error('请输入周期卡名称'));
    }
  }
  validDays(rule: any, value: any, callback: any) {
    const valid_days = this.model.extend.valid_days;
    if (this.model.type != this.weekcard || (valid_days && valid_days > 0)) {
      callback();
    } else {
      return callback(new Error('请输入大于0的天数'));
    }
  }
  getTypeName(type: number) {
    if (type == this.coin) {
      return '云币';
    } else if (type == this.weekcard) {
      return '周期卡';
    } else if (type == this.cash) {
      return '现金券';
    }
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.postNewCode();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  cleanValidate(formName: string) {
    // 清除表单校验的提示
    if (this.$refs[formName]) {
      // 延时执行
      this.$nextTick(function() {
        (this.$refs[formName] as any).clearValidate();
      });
      if (this.model.type == this.cash) {
        this.model.extend.valid_days = 7;
      } else {
        this.model.extend.valid_days = 0;
      }
    }
  }
  @Emit()
  close() {}
  async postNewCode() {
    try {
      this.loading = true;
      const expire_at = moment((this.model as any).expire_at)
        .endOf('day')
        .unix();
      const item = {
        ...this.model,
        expire_at,
      };

      let newModel: iPromoteCode = JSON.parse(JSON.stringify(item));

      /* 周期卡 */
      if (newModel.type == this.weekcard) {
        // newModel.extend.amount = this.model.extend.weekAmount;
        const weekAmount = this.model.extend.weekAmount;
        if (weekAmount != null) {
          newModel.extend.amount = Number(weekAmount * 60);
        } else {
          newModel.extend.amount = -1;
        }
      } else if (newModel.type == this.cash) {
        /* 现金 */
        const cashAcount = this.model.extend.cashAmount;
        if (cashAcount < 0) {
          toast('请输入大于0的现金券金额', 'error');
          return;
        }
        newModel.extend.amount = cashAcount != null ? Math.round(cashAcount * 100) : 0;
        const money_limit = this.model.extend.money_limit;
        newModel.extend.money_limit = money_limit != null ? Math.round(money_limit * 100) : 0;
        // console.log(newModel.extend.money_limit, this.model.extend.money_limit, '----');

        if (this.vilidityDateIndex == this.fixeDate) {
          newModel.extend.valid_days = 0;
          newModel.extend.valid_start_ts = moment(this.start_ts).unix();
          newModel.extend.valid_end_ts = moment(this.end_ts)
            .endOf('day')
            .unix();
        }
      } else if (newModel.type == this.coin) {
        let amount = newModel.extend.amount;
        if (!amount || amount < 0) {
          toast('请输入云币，且云币必须为大于0', 'error');
          return;
        }
      }

      // newModel.extend.amount = Number(newModel.extend.amount);
      const exchange_limit = newModel.exchange_limit;

      newModel.exchange_limit = exchange_limit == 0 || exchange_limit == null ? 0 : exchange_limit;
      newModel.number = newModel.number ? newModel.number : 1;
      const res = await addPromoteCode(newModel);
      toast(`创建成功`, 'success');
      this.$emit('success');
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.model = this.info;

    if (this.model.type == this.weekcard) {
      this.model.extend.weekAmount = this.model.extend.amount;
    } else if (this.model.type == this.cash) {
      this.model.extend.cashAmount = this.model.extend.amount;
      const money_limit = this.model.extend.money_limit;
      //是否限制金额
      if (money_limit && money_limit > 0) {
        this.rechargeTypeIndex = this.limit;
      } else {
        this.rechargeTypeIndex = this.noLimit;
      }

      //是否固定时间
      const validDays = this.model.extend.valid_days;
      if (validDays && validDays > 0) {
        this.vilidityDateIndex = this.getDate;
      } else {
        this.vilidityDateIndex = this.fixeDate;
      }
    }
  }
}
